/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractFormComponent, CommonActions, FormActionPipelines, FormFlowState } from '@gh/builder-shared';
import { ActionFlow, getDialogInitData } from '@gh/common-shared';
import {
  DialogInput,
  FileInvalidEvent,
  InvalidFileReason,
  NotificationService,
  UploadContext,
} from '@gh/core-ui';
import { assign } from 'lodash';
import {
  UserProfileSignature,
  UserProfileSignatureBusinessService,
  UserProfileSignatureDialogConfig,
} from '../../resources';
import { UserProfileSignatureFormService } from './user-profile-signature-form.service';

@Component({
  selector: 'gh-user-profile-signature-dialog',
  template: require('./user-profile-signature-dialog.component.html'),
  styles: [require('./user-profile-signature-dialog.component.scss')],
  viewProviders: [
    UploadContext,
    UserProfileSignatureFormService,
  ],
})
export class UserProfileSignatureDialogComponent extends AbstractFormComponent<UserProfileSignature>
  implements OnInit, DialogInput<UserProfileSignatureDialogConfig> {
  input: UserProfileSignatureDialogConfig;
  uploading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    public form: UserProfileSignatureFormService,
    public dialogRef: MatDialogRef<UserProfileSignatureDialogComponent>,
    private notificationService: NotificationService,
    private pipelines: FormActionPipelines,
    private commonActions: CommonActions,
    private businessService: UserProfileSignatureBusinessService,
  ) {
    super();
  }

  ngOnInit(): void {
    const { signature, ...init } = getDialogInitData(this.dialogData);

    assign(this, init);
    this.form.build({ picture: signature });
  }

  get completeFlow(): ActionFlow<FormFlowState<UserProfileSignature>> {
    return this.pipelines.complete({
      execute: this.commonActions.execute((state) => this.businessService.createSignature(<any>state.value['picture'])),
      finish: (state: FormFlowState<UserProfileSignature>) => this.dialogRef.close(state.form),
    });
  }

  onFileInvalid(event: FileInvalidEvent): void {
    // @ts-ignore
    this.notificationService.error({
      [InvalidFileReason.TooLarge]: 'msg_item_picture_not_correct',
      [InvalidFileReason.NotAccepted]: 'msg_item_picture_not_accepted',
    }[event.reason]);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  startUploading(): void {
    this.uploading = true;
  }

  finishUploading(): void {
    this.uploading = false;
  }
}
